import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "USER_FORM_FORM";
export const UserFormAction = createFormAction(FORM_KEY);

export const FORM_CHANGE_KEY = "FORM_CHANGE_PASS_FORM";
export const PassFormAction = createFormAction(FORM_CHANGE_KEY);



